'use client'

import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { WhatsappIcon, PhoneIcon } from './Icons'
import { contact } from '@/lib/site-config'

export function FloatingButtons(): React.ReactElement {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const onScroll = (): void => setShow(window.scrollY > 400)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="fixed bottom-5 left-5 z-40 flex flex-col gap-3"
        >
          <a
            href={`https://wa.me/${contact.whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="تواصل عبر واتساب"
            className="group inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110"
          >
            <WhatsappIcon className="h-7 w-7" />
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30" />
          </a>
          <a
            href={`tel:${contact.phoneHref}`}
            aria-label="اتصل الآن"
            className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gold-gradient text-charcoal-950 shadow-gold transition-transform hover:scale-110"
          >
            <PhoneIcon className="h-6 w-6" strokeWidth={2} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
